import { useUserState } from 'src/contexts/UserContext';

export const useUserInfo = () => {
  return useUserState();
};
